webpackJsonp([7],{

/***/ "+GkV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/05chahua5.54f71ed.png";

/***/ }),

/***/ "+lSm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['top', _vm.fixed ? 'fixed': '']},[_c('div',{ref:"head",class:['head-wrapper', _vm.fixed ? 'fixed': ''],style:({ backgroundColor: _vm.backgroundColor })},[_c('div',{staticClass:"head"},[_c('router-link',{staticClass:"logo-con",attrs:{"tag":"div","to":{ path: '/index'}}},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("UWQl"),"alt":""}}),_vm._v(" "),_vm._t("logo")],2),_vm._v(" "),_c('div',{staticClass:"right"},[(_vm.isInZcx)?_c('ul',{staticClass:"nav"},[_c('router-link',{staticClass:"item",attrs:{"tag":"li","to":"/index"}},[_vm._v("首页")]),_vm._v(" "),_c('li',{staticClass:"item",on:{"click":function($event){return _vm.gotoPage('/card/#/')}}},[_vm._v("小名片\n        ")]),_vm._v(" "),_c('li',{staticClass:"item",on:{"click":function($event){return _vm.gotoPage('/siteindex/#/')}}},[_vm._v("小官网\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"item",attrs:{"tag":"li","to":"/invest"}},[_vm._v("招商加盟")]),_vm._v(" "),_c('router-link',{staticClass:"item",attrs:{"tag":"li","to":"/help"}},[_vm._v("帮助指引")]),_vm._v(" "),_c('router-link',{staticClass:"item",attrs:{"tag":"li","to":"/about"}},[_vm._v("关于我们")])],1):_c('ul',{staticClass:"nav"},[_c('li',{staticClass:"item",on:{"click":function($event){return _vm.gotoPage('/#/index')}}},[_vm._v("首页")]),_vm._v(" "),_c('li',{staticClass:"item",on:{"click":function($event){return _vm.gotoPage('/card/#/')}}},[_vm._v("小名片\n        ")]),_vm._v(" "),_c('li',{staticClass:"item",on:{"click":function($event){return _vm.gotoPage('/siteindex/#/')}}},[_vm._v("小官网\n        ")]),_vm._v(" "),_c('li',{staticClass:"item",on:{"click":function($event){return _vm.gotoPage('/#/invest')}}},[_vm._v("招商加盟")]),_vm._v(" "),_c('li',{staticClass:"item",on:{"click":function($event){return _vm.gotoPage('/#/help')}}},[_vm._v("帮助指引")]),_vm._v(" "),_c('li',{staticClass:"item",on:{"click":function($event){return _vm.gotoPage('/#/about')}}},[_vm._v("关于我们")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-login",on:{"click":_vm.login}},[_vm._v("登录")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/RJf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/05chahua7.ffc3ecf.png";

/***/ }),

/***/ "/Rpi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner-chahua1.a695c3a.png";

/***/ }),

/***/ "/ciH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "17Js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),

/***/ "1Evz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/05chahua4.6d243a8.png";

/***/ }),

/***/ "2GKE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5-4.4752a09.png";

/***/ }),

/***/ "37/m":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/05chahua3.711ab46.png";

/***/ }),

/***/ "42vp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dish-icon.8b92eaa.png";

/***/ }),

/***/ "4SGW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/01chahua1.51285b4.png";

/***/ }),

/***/ "4blp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_join_vue__ = __webpack_require__("V5cj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bacd7caa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_join_vue__ = __webpack_require__("8Yfl");
function injectStyle (ssrContext) {
  __webpack_require__("nfro")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bacd7caa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_join_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bacd7caa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_join_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "54WX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexpartFive_vue__ = __webpack_require__("uIOS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f6b470a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexpartFive_vue__ = __webpack_require__("TTnC");
function injectStyle (ssrContext) {
  __webpack_require__("f2EM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f6b470a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexpartFive_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f6b470a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexpartFive_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5jIi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/minicard.17e4042.jpg";

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("euKl");


/***/ }),

/***/ "6Flc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"part"},[_c('div',{staticClass:"con"},[_c('div',{staticClass:"number"},[_vm._v("04")]),_vm._v(" "),_c('div',{staticClass:"head"},[_c('div',{staticClass:"title"},[_vm._v("小程序六大优势")]),_vm._v(" "),_c('div',{staticClass:"mark"},[_vm._v("微信小程序不容错过，企业突围的有力武器！")]),_vm._v(" "),_c('div',{staticClass:"spec"},[_vm._v("微信小程序无需安装触手可及，享有微信10亿月活用户，已开放50多个流量入口，深度连接用户、产品与服务，实现商家快速引流、客户轻松消费、互惠共赢创收。")])]),_vm._v(" "),_c('ul',{staticClass:"list"},[_c('li',{staticClass:"item"},[_c('div',{staticClass:"front"},[_c('div',{staticClass:"icon icon1"}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("小程序，大战略")])]),_vm._v(" "),_c('div',{staticClass:"back back1"},[_c('div',{staticClass:"item-title"},[_vm._v("小程序，大战略")]),_vm._v(" "),_c('div',{staticClass:"item-spec"},[_vm._v("小程序属于腾讯战略级项目，微信平台为小程序持续解放60余次新能力，迭代升级速度之快前所未有。")])])]),_vm._v(" "),_c('li',{staticClass:"item"},[_c('div',{staticClass:"front"},[_c('div',{staticClass:"icon icon2"}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("无需安装，触手可及")])]),_vm._v(" "),_c('div',{staticClass:"back back2"},[_c('div',{staticClass:"item-title"},[_vm._v("无需安装，触手可及")]),_vm._v(" "),_c('div',{staticClass:"item-spec"},[_vm._v("用户扫一扫或搜一下即可打开应用，不用担心是否安装太多应用的问题，应用将无处不在随处可用，也无需安装卸载，节省手机流量，释放手机内存。简化了用户使用步骤，提供了更轻松、更流畅的用户体验。")])])]),_vm._v(" "),_c('li',{staticClass:"item"},[_c('div',{staticClass:"front"},[_c('div',{staticClass:"icon icon3"}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("低门槛、低成本、高可用")])]),_vm._v(" "),_c('div',{staticClass:"back back3"},[_c('div',{staticClass:"item-title"},[_vm._v("低门槛、低成本、高可用")]),_vm._v(" "),_c('div',{staticClass:"item-spec"},[_vm._v("技术门槛低，开发周期短，无需适应多终端、多系统，大大节省时间、人力、金钱的成本；同时，可还原APP 80%以上的功能，操作更简单、使用更方便")])])]),_vm._v(" "),_c('li',{staticClass:"item"},[_c('div',{staticClass:"front"},[_c('div',{staticClass:"icon icon4"}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("推广更简单，营销更高效")])]),_vm._v(" "),_c('div',{staticClass:"back back4"},[_c('div',{staticClass:"item-title"},[_vm._v("推广更简单，营销更高效")]),_vm._v(" "),_c('div',{staticClass:"item-spec"},[_vm._v("小程序具备多种推广方式，可以绑定公众号，方便用户直接跳转使用；可以随手生成二维码、展示在朋友圈、印制在各种宣传资料……，帮助商家品牌全面曝光，促进用户快速裂变，从而带来更多的用户。")])])]),_vm._v(" "),_c('li',{staticClass:"item"},[_c('div',{staticClass:"front"},[_c('div',{staticClass:"icon icon5"}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("运营成本低、自带高流量")])]),_vm._v(" "),_c('div',{staticClass:"back back5"},[_c('div',{staticClass:"item-title"},[_vm._v("运营成本低、自带高流量")]),_vm._v(" "),_c('div',{staticClass:"item-spec"},[_vm._v("小程序运行于微信，直接享有10亿的月活用户，及万亿市场红利。小程序已开放的50多个流量入口，包括附近5公里可见，自动“吸睛”引流，为商家带来更多商机。")])])]),_vm._v(" "),_c('li',{staticClass:"item"},[_c('div',{staticClass:"front"},[_c('div',{staticClass:"icon icon6"}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("轻应用、大生态")])]),_vm._v(" "),_c('div',{staticClass:"back back6"},[_c('div',{staticClass:"item-title"},[_vm._v("轻应用、大生态")]),_vm._v(" "),_c('div',{staticClass:"item-spec"},[_vm._v("传统企业要想发展更多的优势，必须依据产品+线下+线上同时并行，完善网络系统，微信小程序可以很好的打通用户、内容资讯、商品服务之间的联系，直接在微生态体系内完成商业模式的闭环，实现用户与商品与服务的无缝链接，商家快速引流，客户轻松消费、互惠共赢创收。")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Q0P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommonFooter_vue__ = __webpack_require__("z2iv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bf3b20d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommonFooter_vue__ = __webpack_require__("dYhO");
function injectStyle (ssrContext) {
  __webpack_require__("oEwB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bf3b20d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommonFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bf3b20d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommonFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7v5/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexItem_vue__ = __webpack_require__("7vmQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bf83cb3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexItem_vue__ = __webpack_require__("tu8q");
function injectStyle (ssrContext) {
  __webpack_require__("MmRU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3bf83cb3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bf83cb3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7vmQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    img: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    text: {
      type: Array,
      default: []
    },
    mode: {
      type: String,
      default: 'left'
    },
    index: {
      type: null
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    next: function next() {
      this.$emit('next', this.index);
    }
  },
  components: {}
});

/***/ }),

/***/ "8Yfl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"part"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"cell cell1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.realname),expression:"realname"}],attrs:{"type":"text","placeholder":"联系人"},domProps:{"value":(_vm.realname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.realname=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"cell cell2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mobile),expression:"mobile"}],attrs:{"type":"text","placeholder":"电话"},domProps:{"value":(_vm.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mobile=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"cell cell1 speical"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"}],attrs:{"type":"text","placeholder":"意向代理城市"},domProps:{"value":(_vm.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"cell cell2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"text","placeholder":"邮箱"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('button',{staticClass:"btn btn-submit",on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.submitting ? '提交申请中...' : '提交申请'))]),_vm._v(" "),_c('span',{staticClass:"mark"},[_vm._v("(我们会在48小时内与您联系)")])])]),_vm._v(" "),_c('success',{ref:"dialog"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info"},[_c('div',{staticClass:"title"},[_vm._v("\n      联系方式"),_c('span',{staticClass:"small"},[_vm._v("CONTACT US")])]),_vm._v(" "),_c('div',{staticClass:"cell"},[_c('i',{staticClass:"icon-tel"}),_vm._v("\n      联系电话  186 8021 1000\n    ")]),_vm._v(" "),_c('div',{staticClass:"cell"},[_c('i',{staticClass:"icon-mail"}),_vm._v("\n      电子邮箱  chenjianjun@xcxzhan.com\n    ")]),_vm._v(" "),_c('div',{staticClass:"qrcode"},[_c('img',{attrs:{"src":__webpack_require__("5jIi"),"alt":""}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("9+r8"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"small",staticStyle:{"float":"left"}},[_vm._v("扫码试用小名片")]),_vm._v(" "),_c('div',{staticClass:"small",staticStyle:{"float":"left","margin-left":"120px"}},[_vm._v("扫码创建小官网")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_vm._v("\n      招商加盟"),_c('span',{staticClass:"small"},[_vm._v("CHINA MERCHANTS TO JOIN ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8krA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_business_CommonHeader__ = __webpack_require__("WOEh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_business_CommonFooter__ = __webpack_require__("7Q0P");
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {
    CommonHeader: __WEBPACK_IMPORTED_MODULE_0__components_business_CommonHeader__["a" /* default */],
    CommonFooter: __WEBPACK_IMPORTED_MODULE_1__components_business_CommonFooter__["a" /* default */]
  }
});

/***/ }),

/***/ "9+r8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/miniweb.088d1b5.jpg";

/***/ }),

/***/ "9bH9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dish3.67e5bc4.png";

/***/ }),

/***/ "A/SA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/05chahua2.f6dac7b.png";

/***/ }),

/***/ "AUVv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner-chahua3.f549711.png";

/***/ }),

/***/ "BJUD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D9GN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexPartTwo_vue__ = __webpack_require__("JhY2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a1fb872_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexPartTwo_vue__ = __webpack_require__("Dytq");
function injectStyle (ssrContext) {
  __webpack_require__("fKKX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a1fb872"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexPartTwo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a1fb872_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexPartTwo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Dytq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"bg-left"}),_vm._v(" "),_c('div',{staticClass:"part"},[_c('div',{staticClass:"phone"},[_c('div',{staticClass:"phone-img"},_vm._l((_vm.imgs),function(item,index){return _c('transition',{key:index,attrs:{"name":"slide"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.showIndex == index),expression:"showIndex == index"}],attrs:{"src":item,"alt":""}})])}),1)]),_vm._v(" "),_c('div',{staticClass:"number"},[_vm._v("02")]),_vm._v(" "),_c('div',{staticClass:"con"},[_c('div',{staticClass:"title"},[_vm._v("为销售赋能的小名片")]),_vm._v(" "),_c('div',{staticClass:"mark"},[_vm._v("产品展示")]),_vm._v(" "),_c('ul',{staticClass:"list"},[_c('li',{staticClass:"item"},[_c('div',{staticClass:"icon icon1"}),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v("小名片展示")]),_vm._v(" "),_c('div',{staticClass:"info"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"link"},[_c('div',{staticClass:"link-item",attrs:{"data-index":"0"},on:{"mouseenter":_vm.changeImage}},[_vm._v("名片信息")]),_vm._v(" "),_c('div',{staticClass:"link-item",attrs:{"data-index":"1"},on:{"mouseenter":_vm.changeImage}},[_vm._v("个人信息")]),_vm._v(" "),_c('div',{staticClass:"link-item",attrs:{"data-index":"2"},on:{"mouseenter":_vm.changeImage}},[_vm._v("更多信息")])])])]),_vm._v(" "),_c('li',{staticClass:"item"},[_c('div',{staticClass:"icon icon2"}),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v("绑定小官网")]),_vm._v(" "),_c('div',{staticClass:"info"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"link"},[_c('div',{staticClass:"link-item",attrs:{"data-index":"3"},on:{"mouseenter":_vm.changeImage}},[_vm._v("查看名片")]),_vm._v(" "),_c('div',{staticClass:"link-item",attrs:{"data-index":"4"},on:{"mouseenter":_vm.changeImage}},[_vm._v("查看企业小官网")]),_vm._v(" "),_c('div',{staticClass:"link-item",attrs:{"data-index":"5"},on:{"mouseenter":_vm.changeImage}},[_vm._v("小官网多样式介绍")])])])]),_vm._v(" "),_c('li',{staticClass:"item"},[_c('div',{staticClass:"icon icon3"}),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v("销售雷达展示")]),_vm._v(" "),_c('div',{staticClass:"info"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"link"},[_c('div',{staticClass:"link-item",attrs:{"data-index":"6"},on:{"mouseenter":_vm.changeImage}},[_vm._v("实时推送访客消息")]),_vm._v(" "),_c('div',{staticClass:"link-item",attrs:{"data-index":"7"},on:{"mouseenter":_vm.changeImage}},[_vm._v("不加微信好友沟通")]),_vm._v(" "),_c('div',{staticClass:"link-item",attrs:{"data-index":"8"},on:{"mouseenter":_vm.changeImage}},[_vm._v("即时聊天")])])])]),_vm._v(" "),_c('li',{staticClass:"item"},[_c('div',{staticClass:"icon icon4"}),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v("智能AI分析")]),_vm._v(" "),_c('div',{staticClass:"info"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"link"},[_c('div',{staticClass:"link-item",attrs:{"data-index":"9"},on:{"mouseenter":_vm.changeImage}},[_vm._v("访客数据分析")]),_vm._v(" "),_c('div',{staticClass:"link-item",attrs:{"data-index":"10"},on:{"mouseenter":_vm.changeImage}},[_vm._v("访客互动情况")]),_vm._v(" "),_c('div',{staticClass:"link-item",attrs:{"data-index":"11"},on:{"mouseenter":_vm.changeImage}},[_vm._v("销售人员能力分析")]),_vm._v(" "),_c('div',{staticClass:"link-item",attrs:{"data-index":"12"},on:{"mouseenter":_vm.changeImage}},[_vm._v("销售详情分析")])])])]),_vm._v(" "),_c('li',{staticClass:"item"},[_c('div',{staticClass:"icon icon5"}),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v("商机SCRM")]),_vm._v(" "),_c('div',{staticClass:"info"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"link"},[_c('div',{staticClass:"link-item",attrs:{"data-index":"13"},on:{"mouseenter":_vm.changeImage}},[_vm._v("商机标签化管理")]),_vm._v(" "),_c('div',{staticClass:"link-item",attrs:{"data-index":"14"},on:{"mouseenter":_vm.changeImage}},[_vm._v("销售跟进记录")]),_vm._v(" "),_c('div',{staticClass:"link-item",attrs:{"data-index":"15"},on:{"mouseenter":_vm.changeImage}},[_vm._v("客户访问轨迹")]),_vm._v(" "),_c('div',{staticClass:"link-item",attrs:{"data-index":"16"},on:{"mouseenter":_vm.changeImage}},[_vm._v("客户兴趣分析")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',[_vm._v("统一公司形象，全员分享，小名片直达企业官网，产品、服务的展现")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',[_vm._v("企业官网、产品、服务的完整展现")]),_vm._v(" "),_c('p',[_vm._v("帮助访客第一时间了解企业，更快促成业务交流")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',[_vm._v("访问消息实时推送，名片访客即客户，不加好友就可微信沟通不错过每个商机；探测访客访问动态，让销售沟通更高效")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',[_vm._v("分析客户兴趣与活跃度，挖掘深度用户")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('p',[_vm._v("助销售进行客户标签化管理，客户跟进记录管理，客户AI分析")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F2gn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"point",staticClass:"point"},[_vm._t("tab-point")],2),_vm._v(" "),_c('div',{ref:"content",staticClass:"content"},[_vm._t("tab-content")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FD+k":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-3.3522ddc.png";

/***/ }),

/***/ "H8YX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dish2.e485e1a.png";

/***/ }),

/***/ "IpGy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexPartFour_vue__ = __webpack_require__("oG5k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45891abc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexPartFour_vue__ = __webpack_require__("6Flc");
function injectStyle (ssrContext) {
  __webpack_require__("z67V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45891abc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexPartFour_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45891abc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexPartFour_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JhY2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_index_phone_1_1_png__ = __webpack_require__("ex59");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_index_phone_1_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_images_index_phone_1_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_index_phone_1_2_png__ = __webpack_require__("eD7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_index_phone_1_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_index_phone_1_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_index_phone_1_3_png__ = __webpack_require__("THYX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_index_phone_1_3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_index_phone_1_3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_index_phone_2_1_png__ = __webpack_require__("eqKx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_index_phone_2_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_index_phone_2_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_index_phone_2_2_png__ = __webpack_require__("xJbw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_index_phone_2_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_index_phone_2_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_index_phone_2_3_png__ = __webpack_require__("qZYs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_index_phone_2_3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_index_phone_2_3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_index_phone_3_1_png__ = __webpack_require__("v4eZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_index_phone_3_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_index_phone_3_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_index_phone_3_2_png__ = __webpack_require__("lrYJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_index_phone_3_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_index_phone_3_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_index_phone_3_3_png__ = __webpack_require__("FD+k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_index_phone_3_3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_index_phone_3_3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_index_phone_4_1_png__ = __webpack_require__("xESo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_index_phone_4_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_index_phone_4_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_index_phone_4_2_png__ = __webpack_require__("Q9S4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_index_phone_4_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_index_phone_4_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_index_phone_4_3_png__ = __webpack_require__("fgbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_images_index_phone_4_3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_images_index_phone_4_3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_index_phone_4_4_png__ = __webpack_require__("azX7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_index_phone_4_4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_index_phone_4_4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_index_phone_5_1_png__ = __webpack_require__("KCjg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_images_index_phone_5_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_images_index_phone_5_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_index_phone_5_2_png__ = __webpack_require__("kQvN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_images_index_phone_5_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_images_index_phone_5_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_index_phone_5_3_png__ = __webpack_require__("ozb2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_images_index_phone_5_3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_images_index_phone_5_3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_index_phone_5_4_png__ = __webpack_require__("2GKE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_images_index_phone_5_4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_images_index_phone_5_4_png__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//























/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      phoneImgShow: true,
      imgs: [__WEBPACK_IMPORTED_MODULE_0__assets_images_index_phone_1_1_png___default.a, __WEBPACK_IMPORTED_MODULE_1__assets_images_index_phone_1_2_png___default.a, __WEBPACK_IMPORTED_MODULE_2__assets_images_index_phone_1_3_png___default.a, __WEBPACK_IMPORTED_MODULE_3__assets_images_index_phone_2_1_png___default.a, __WEBPACK_IMPORTED_MODULE_4__assets_images_index_phone_2_2_png___default.a, __WEBPACK_IMPORTED_MODULE_5__assets_images_index_phone_2_3_png___default.a, __WEBPACK_IMPORTED_MODULE_6__assets_images_index_phone_3_1_png___default.a, __WEBPACK_IMPORTED_MODULE_7__assets_images_index_phone_3_2_png___default.a, __WEBPACK_IMPORTED_MODULE_8__assets_images_index_phone_3_3_png___default.a, __WEBPACK_IMPORTED_MODULE_9__assets_images_index_phone_4_1_png___default.a, __WEBPACK_IMPORTED_MODULE_10__assets_images_index_phone_4_2_png___default.a, __WEBPACK_IMPORTED_MODULE_11__assets_images_index_phone_4_3_png___default.a, __WEBPACK_IMPORTED_MODULE_12__assets_images_index_phone_4_4_png___default.a, __WEBPACK_IMPORTED_MODULE_13__assets_images_index_phone_5_1_png___default.a, __WEBPACK_IMPORTED_MODULE_14__assets_images_index_phone_5_2_png___default.a, __WEBPACK_IMPORTED_MODULE_15__assets_images_index_phone_5_3_png___default.a, __WEBPACK_IMPORTED_MODULE_16__assets_images_index_phone_5_4_png___default.a],
      showIndex: 0
    };
  },

  methods: {
    changeImage: function changeImage(e) {
      var index = +e.currentTarget.getAttribute('data-index');
      this.showIndex = index;
      /*
      setTimeout(() => {
        this.imgSrc = this.imgs[index]
        this.phoneImgShow = true
      }, 20);*/
    }
  },
  components: {}
});

/***/ }),

/***/ "K4Lr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KCjg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5-1.11fab89.png";

/***/ }),

/***/ "KgEV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"dialog"},[_c('div',{staticClass:"mask",on:{"click":_vm.maskClick}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('i',{staticClass:"icon-success"}),_vm._v(" "),_c('div',{staticClass:"tip"},[_vm._v("提交申请成功")]),_vm._v(" "),_c('small',[_vm._v("我们会在48小时内与您取得联系")]),_vm._v(" "),_c('button',{on:{"click":_vm.maskClick}},[_vm._v("关闭")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MmRU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NMB9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexPartSix_vue__ = __webpack_require__("qy4u");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e8a1964_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexPartSix_vue__ = __webpack_require__("O9uy");
function injectStyle (ssrContext) {
  __webpack_require__("xSk2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e8a1964"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexPartSix_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e8a1964_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexPartSix_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O38v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animate__ = __webpack_require__("nlmA");



/* harmony default export */ __webpack_exports__["a"] = ({
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.scrollToTop();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, form, next) {
    this.scrollToTop();
    next();
  },

  methods: {
    scrollToTop: function scrollToTop() {
      //animate(document.documentElement, 'scrollTop', 0, 0)
      window.scroll({ top: 0 });
    }
  }
});

/***/ }),

/***/ "O9uy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"part"},[_c('div',{staticClass:"number"},[_vm._v("06")]),_vm._v(" "),_c('join')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q9S4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4-2.67cb670.png";

/***/ }),

/***/ "RjxN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IndexItem__ = __webpack_require__("7v5/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_01chahua1_png__ = __webpack_require__("4SGW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_01chahua1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_01chahua1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_01chahua2_png__ = __webpack_require__("YYTu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_01chahua2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_01chahua2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_01chahua3_png__ = __webpack_require__("yvie");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_01chahua3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_01chahua3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_01chahua4_png__ = __webpack_require__("c0mY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_01chahua4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_01chahua4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_dish1_png__ = __webpack_require__("sb7x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_dish1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_dish1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_dish2_png__ = __webpack_require__("H8YX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_dish2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_dish2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_dish3_png__ = __webpack_require__("9bH9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_dish3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_dish3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_dish4_png__ = __webpack_require__("rKbF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_dish4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_dish4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_tab__ = __webpack_require__("sXQ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_dom__ = __webpack_require__("xfd8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














var area = [{
  x: {
    max: 464,
    min: 330
  },
  y: {
    max: 262,
    min: 104
  }
}, {
  x: {
    max: 607,
    min: 510
  },
  y: {
    max: 262,
    min: 104
  }
}, {
  x: {
    max: 607,
    min: 510
  },
  y: {
    max: 413,
    min: 262
  }
}, {
  x: {
    max: 464,
    min: 330
  },
  y: {
    max: 413,
    min: 262
  }
}];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dishFixed: false,
      list: [{
        id: 'index-part-one-one',
        img: __WEBPACK_IMPORTED_MODULE_1__assets_images_01chahua1_png___default.a,
        title: '全面链接  人脉裂变',
        mode: 'left',
        text: ['让销售连接微信10亿用户，一键将小程序分享给微信好友、微信群、朋友圈，通过朋友将服务与产品“发出去”，形成快速传播', '企业员工只需分享个人名片小程序至微信，销售雷达即可进行商机捕捉']
      }, {
        id: 'index-part-one-two',
        img: __WEBPACK_IMPORTED_MODULE_2__assets_images_01chahua2_png___default.a,
        title: '访客轨迹  智能预测',
        mode: 'right',
        text: ['客户查看名片、查看企业官网等行为都将被记录，并且实现访客IM既时通讯，智能数据分析挖掘高度意向客户，预测客户成交率，精准营销快速转化', '可视化分析系统，实际监控销售行为，帮助企业沉淀客户流量资产']
      }, {
        id: 'index-part-one-three',
        img: __WEBPACK_IMPORTED_MODULE_3__assets_images_01chahua3_png___default.a,
        title: '品牌传播  企业展示',
        mode: 'left',
        text: ['开启全员社交流量，统一展示公司的企业品牌及产品信息，不仅仅是销售，还有市场、人事等员工都可以开通小名片，为企业增加新的品牌宣传渠道']
      }, {
        id: 'index-part-one-four',
        img: __WEBPACK_IMPORTED_MODULE_4__assets_images_01chahua4_png___default.a,
        title: '信息智库  信任背书',
        mode: 'right',
        text: ['小名片可展示企业销售员工的联系方式，小官网可展示企业介绍，业务及产品详情', '客户存储的不只是名片，自动保存的还有个人和公司信息，方便客户随时查看业务和产品介绍详情']
      }],
      active: 0,
      dishImg: __WEBPACK_IMPORTED_MODULE_5__assets_images_dish1_png___default.a
    };
  },

  methods: {
    itemNext: function itemNext(index) {
      this.$refs.tab.tab((index + 1) % this.list.length);
    },
    checkIndex: function checkIndex(x, y) {
      var index = area.findIndex(function (item) {
        if (x >= item.x.min && x <= item.x.max && y >= item.y.min && y <= item.y.max) return true;
      });
      return index;
    },
    getDishImg: function getDishImg(index) {
      switch (index) {
        case 0:
          return __WEBPACK_IMPORTED_MODULE_5__assets_images_dish1_png___default.a;
        case 1:
          return __WEBPACK_IMPORTED_MODULE_6__assets_images_dish2_png___default.a;
        case 2:
          return __WEBPACK_IMPORTED_MODULE_7__assets_images_dish3_png___default.a;
        case 3:
          return __WEBPACK_IMPORTED_MODULE_8__assets_images_dish4_png___default.a;
        default:
          return __WEBPACK_IMPORTED_MODULE_5__assets_images_dish1_png___default.a;
      }
    },
    handleDishClick: function handleDishClick(e) {
      var index = this.checkIndex(e.layerX, e.layerY);
      this.gotoTarget(this.list[index].id);
    },
    gotoTarget: function gotoTarget(id) {
      if (!id) return;
      var top = document.querySelector('#' + id).offsetTop;
      window.scroll({
        top: top + 500,
        behavior: 'smooth'
      });
      //animate(document.documentElement,'scrollTop',top - 100,600)
    }
  },
  mounted: function mounted() {
    var _this = this;

    //this.$bodyTop = this.$refs.body.offsetTop
    //this.$itemTops = this.$refs.items.map(item => item.offsetTop + this.$bodyTop)
    // document.addEventListener('scroll',this.handleScroll)
    this.$refs.dishicon.addEventListener('mousemove', function (e) {
      var x = e.layerX,
          y = e.layerY,
          index = _this.checkIndex(x, y);
      if (index !== -1) {
        _this.dishImg = _this.getDishImg(index);
      }
    });
  },

  computed: {},
  components: {
    IndexItem: __WEBPACK_IMPORTED_MODULE_0__IndexItem__["a" /* default */],
    Tab: __WEBPACK_IMPORTED_MODULE_9__common_tab__["a" /* default */]
  }
});

/***/ }),

/***/ "Rvrj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_dom__ = __webpack_require__("xfd8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isInZcx: {
      type: Boolean,
      default: true
    },
    backgroundColor: {
      type: String,
      default: '#fff'
    }
  },
  data: function data() {
    return {
      fixed: false
    };
  },

  methods: {
    login: function login() {
      window.location = '/admin/#/login';
    },
    gotoPage: function gotoPage(location) {
      window.location = location;
    }
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('scroll', function (e) {
      var scrollTop = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_dom__["a" /* getWindowScrollTop */])();
      var delta = 86;

      if (scrollTop >= delta) {
        !_this.fixed && setTimeout(function () {
          _this.$refs.head.style.top = 0;
        }, 40);
        _this.fixed = true;
      } else {
        _this.fixed = false;
        _this.$refs.head.style.top = '-86px';
      }
    });
  },

  components: {}
});

/***/ }),

/***/ "S+vg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('common-header'),_vm._v(" "),_c('keep-alive',[_c('router-view')],1),_vm._v(" "),_c('common-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "THYX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-3.61fa415.png";

/***/ }),

/***/ "TTnC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"part"},[_c('div',{staticClass:"number"},[_vm._v("05")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"con"},[_c('tab',{ref:"tab",staticClass:"tab",on:{"tab":_vm.tab}},[_c('div',{staticClass:"point",attrs:{"slot":"tab-point"},slot:"tab-point"},[_c('div',{staticClass:"point-item",attrs:{"data-index":"0"},on:{"mouseover":_vm.handleMouseEnter}},[_c('div',{staticClass:"icon icon1"}),_vm._v(" "),_c('div',{staticClass:"item-text"},[_vm._v("微信搜索")])]),_vm._v(" "),_c('div',{staticClass:"point-item",attrs:{"data-index":"1"},on:{"mouseover":_vm.handleMouseEnter}},[_c('div',{staticClass:"icon icon2"}),_vm._v(" "),_c('div',{staticClass:"item-text"},[_vm._v("线下扫码")])]),_vm._v(" "),_c('div',{staticClass:"point-item",attrs:{"data-index":"2"},on:{"mouseover":_vm.handleMouseEnter}},[_c('div',{staticClass:"icon icon3"}),_vm._v(" "),_c('div',{staticClass:"item-text"},[_vm._v("推荐给好友")])]),_vm._v(" "),_c('div',{staticClass:"point-item",attrs:{"data-index":"3"},on:{"mouseover":_vm.handleMouseEnter}},[_c('div',{staticClass:"icon icon4"}),_vm._v(" "),_c('div',{staticClass:"item-text"},[_vm._v("小程序列表")])]),_vm._v(" "),_c('div',{staticClass:"point-item",attrs:{"data-index":"4"},on:{"mouseover":_vm.handleMouseEnter}},[_c('div',{staticClass:"icon icon5"}),_vm._v(" "),_c('div',{staticClass:"item-text"},[_vm._v("附近小程序")])]),_vm._v(" "),_c('div',{staticClass:"point-item",attrs:{"data-index":"5"},on:{"mouseover":_vm.handleMouseEnter}},[_c('div',{staticClass:"icon icon6"}),_vm._v(" "),_c('div',{staticClass:"item-text"},[_vm._v("公众号关联")])]),_vm._v(" "),_c('div',{staticClass:"point-item",attrs:{"data-index":"6"},on:{"mouseover":_vm.handleMouseEnter}},[_c('div',{staticClass:"icon icon7"}),_vm._v(" "),_c('div',{staticClass:"item-text"},[_vm._v("公众号文章")])]),_vm._v(" "),_c('div',{staticClass:"point-item",attrs:{"data-index":"7"},on:{"mouseover":_vm.handleMouseEnter}},[_c('div',{staticClass:"icon icon8"}),_vm._v(" "),_c('div',{staticClass:"item-text"},[_vm._v("分享到群")])]),_vm._v(" "),_c('div',{staticClass:"point-item",attrs:{"data-index":"8"},on:{"mouseover":_vm.handleMouseEnter}},[_c('div',{staticClass:"icon icon9"}),_vm._v(" "),_c('div',{staticClass:"item-text"},[_vm._v("聊天顶部")])])]),_vm._v(" "),_c('div',{staticClass:"content",attrs:{"slot":"tab-content"},slot:"tab-content"},[_c('div',{staticClass:"content-item"},[_c('transition',{attrs:{"name":"slide"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabActive == 0),expression:"tabActive == 0"}],staticClass:"item-img",attrs:{"src":__webpack_require__("g11x"),"alt":""}})])],1),_vm._v(" "),_c('div',{staticClass:"content-item"},[_c('transition',{attrs:{"name":"slide"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabActive == 1),expression:"tabActive == 1"}],staticClass:"item-img",attrs:{"src":__webpack_require__("A/SA"),"alt":""}})])],1),_vm._v(" "),_c('div',{staticClass:"content-item"},[_c('transition',{attrs:{"name":"slide"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabActive == 2),expression:"tabActive == 2"}],staticClass:"item-img",attrs:{"src":__webpack_require__("37/m"),"alt":""}})])],1),_vm._v(" "),_c('div',{staticClass:"content-item"},[_c('transition',{attrs:{"name":"slide"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabActive == 3),expression:"tabActive == 3"}],staticClass:"item-img",attrs:{"src":__webpack_require__("1Evz"),"alt":""}})])],1),_vm._v(" "),_c('div',{staticClass:"content-item"},[_c('transition',{attrs:{"name":"slide"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabActive == 4),expression:"tabActive == 4"}],staticClass:"item-img",attrs:{"src":__webpack_require__("+GkV"),"alt":""}})])],1),_vm._v(" "),_c('div',{staticClass:"content-item"},[_c('transition',{attrs:{"name":"slide"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabActive == 5),expression:"tabActive == 5"}],staticClass:"item-img",attrs:{"src":__webpack_require__("WMtt"),"alt":""}})])],1),_vm._v(" "),_c('div',{staticClass:"content-item"},[_c('transition',{attrs:{"name":"slide"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabActive == 6),expression:"tabActive == 6"}],staticClass:"item-img",attrs:{"src":__webpack_require__("/RJf"),"alt":""}})])],1),_vm._v(" "),_c('div',{staticClass:"content-item"},[_c('transition',{attrs:{"name":"slide"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabActive == 7),expression:"tabActive == 7"}],staticClass:"item-img",attrs:{"src":__webpack_require__("r+22"),"alt":""}})])],1),_vm._v(" "),_c('div',{staticClass:"content-item"},[_c('transition',{attrs:{"name":"slide"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabActive == 8),expression:"tabActive == 8"}],staticClass:"item-img",attrs:{"src":__webpack_require__("UZID"),"alt":""}})])],1)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head"},[_c('div',{staticClass:"title"},[_vm._v("小程序核心使用场景")]),_vm._v(" "),_c('div',{staticClass:"mark"},[_vm._v("享有微信10亿月活用户")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U3uk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexPartOne_vue__ = __webpack_require__("RjxN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1421c32d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexPartOne_vue__ = __webpack_require__("aF6n");
function injectStyle (ssrContext) {
  __webpack_require__("VqS4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1421c32d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexPartOne_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1421c32d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexPartOne_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UWQl":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "UZID":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/05chahua9.2cd6f52.png";

/***/ }),

/***/ "V5cj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__siteindex_api__ = __webpack_require__("ua9D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__siteindex_join_success__ = __webpack_require__("bRi5");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var isEmail = __webpack_require__("lfIY");
var isPhone = __webpack_require__("MS/R");
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      realname: '',
      mobile: '',
      address: '',
      email: '',
      submitting: false
    };
  },

  methods: {
    verify: function verify(data) {
      if (!data.realname) return '请填写您的名字';
      if (!isPhone(data.mobile)) return '请填写您的联系电话';
      if (!isEmail(data.email)) return '请填写您的邮箱';
    },
    submit: function submit() {
      var _this = this;

      if (this.submitting) return;
      var data = {
        realname: this.realname,
        mobile: this.mobile,
        address: this.address,
        email: this.email
      };
      var result = this.verify(data);
      if (result) {
        window.alert(result);
        return;
      }
      this.submitting = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__siteindex_api__["a" /* invest */])(data).then(function () {
        _this.$refs.dialog.show(true);
        _this.submitting = false;
      }).catch(function (err) {
        _this.submitting = false;
      });
    }
  },
  components: {
    Success: __WEBPACK_IMPORTED_MODULE_1__siteindex_join_success__["a" /* default */]
  }
});

/***/ }),

/***/ "VqS4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WMtt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/05chahua6.7cf50a2.png";

/***/ }),

/***/ "WOEh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommonHeader_vue__ = __webpack_require__("Rvrj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1445a655_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommonHeader_vue__ = __webpack_require__("+lSm");
function injectStyle (ssrContext) {
  __webpack_require__("K4Lr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1445a655"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommonHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1445a655_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommonHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YYTu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/01chahua2.97f4a1b.png";

/***/ }),

/***/ "YeFZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"part"},[_c('div',{staticClass:"number"},[_vm._v("03")]),_vm._v(" "),_c('div',{staticClass:"bg-right"}),_vm._v(" "),_c('div',{staticClass:"con"},[_c('div',{staticClass:"title"},[_vm._v("四大核心能力与技术")]),_vm._v(" "),_c('div',{staticClass:"mark"},[_vm._v("全面赋能企业营销")]),_vm._v(" "),_c('ul',{staticClass:"list"},[_c('li',{staticClass:"item"},[_c('div',{staticClass:"icon icon1"}),_vm._v(" "),_c('div',{staticClass:"item-t"},[_c('div',{staticClass:"strong"},[_vm._v("小程序名片")]),_vm._v(" "),_c('div',{staticClass:"small"},[_vm._v("营销社交化")])]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('div',{staticClass:"text-item"},[_vm._v("配备流动大数据，创建小名片只用7秒")]),_vm._v(" "),_c('div',{staticClass:"text-item"},[_vm._v("不只是一张名片，更是连接企业和客户的连接器")]),_vm._v(" "),_c('div',{staticClass:"text-item"},[_vm._v("名片直达公司官网，告别搜索竞价排名")]),_vm._v(" "),_c('div',{staticClass:"text-item"},[_vm._v("客户存储的不只是名片，还自动保存个人和公司信息")])])]),_vm._v(" "),_c('li',{staticClass:"item"},[_c('div',{staticClass:"icon icon2"}),_vm._v(" "),_c('div',{staticClass:"item-t"},[_c('div',{staticClass:"strong"},[_vm._v("智能获客")]),_vm._v(" "),_c('div',{staticClass:"small"},[_vm._v("销售智能化")])]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('div',{staticClass:"text-item"},[_vm._v("云技术流定，弹性云满足用户动态增长，支持全渠道获客户，全场景使用，连接微信10亿流量")]),_vm._v(" "),_c('div',{staticClass:"text-item"},[_vm._v("线上线下场景营销利器")]),_vm._v(" "),_c('div',{staticClass:"text-item"},[_vm._v("客户通过扫描二维码，可以看见销售人员的个人信息、产品信息、公司信息和商城信息")])])]),_vm._v(" "),_c('li',{staticClass:"item"},[_c('div',{staticClass:"icon icon3"}),_vm._v(" "),_c('div',{staticClass:"item-t"},[_c('div',{staticClass:"strong"},[_vm._v("客户管理")]),_vm._v(" "),_c('div',{staticClass:"small"},[_vm._v("管理简单化")])]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('div',{staticClass:"text-item"},[_vm._v("管理升级，随时掌握销售动态，实时同步客户进展")]),_vm._v(" "),_c('div',{staticClass:"text-item"},[_vm._v("雷达实时推送客户动态，AI算法不错过每个商机")]),_vm._v(" "),_c('div',{staticClass:"text-item"},[_vm._v("智能分析客户兴趣和活跃度，智能数据挖掘高度意向客户")]),_vm._v(" "),_c('div',{staticClass:"text-item"},[_vm._v("离职员工一键完成工作交接，公司客户永不流失")])])]),_vm._v(" "),_c('li',{staticClass:"item"},[_c('div',{staticClass:"icon icon4"}),_vm._v(" "),_c('div',{staticClass:"item-t"},[_c('div',{staticClass:"strong"},[_vm._v("人人销售")]),_vm._v(" "),_c('div',{staticClass:"small"},[_vm._v("销售人人化")])]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('div',{staticClass:"text-item"},[_vm._v("极简轻量化设计，支持企业VI统一，小官网行业模板多样化，手机端、移动端双模编辑")]),_vm._v(" "),_c('div',{staticClass:"text-item"},[_vm._v("开启全员社交流量变现，为企业增加新的获客宣传渠道")]),_vm._v(" "),_c('div',{staticClass:"text-item"},[_vm._v("全员分享小名片直达企业官网、产品、服务的展现")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YisL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZWHs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aBSl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page_Index__ = __webpack_require__("qGuv");





var Invest = function Invest() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "MKmy"));
};
var Help = function Help() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "Ug76"));
};
var About = function About() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "Zt/W"));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    redirect: '/index'
  }, {
    path: '/index',
    name: 'index',
    component: __WEBPACK_IMPORTED_MODULE_2__page_Index__["a" /* default */]
  }, {
    path: '/invest',
    name: 'invest',
    component: Invest
  }, {
    path: '/help',
    name: 'help',
    component: Help
  }, {
    path: '/about',
    name: 'about',
    component: About
  }]
}));

/***/ }),

/***/ "aF6n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"body",staticClass:"wrapper",class:[_vm.dishFixed ? 'fixed' : '']},[_c('div',{ref:"top",staticClass:"top"},[_c('div',{staticClass:"con"},[_c('div',{staticClass:"title"},[_vm._v("为销售赋能的名片SCRM")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("企业销售与客户之间进行商务社交的过程，小名片帮助企业实现品牌传播，产品营销，且对销售过程进行监管，留存客户资源")]),_vm._v(" "),_c('div',{staticClass:"dish"},[_c('div',{staticClass:"dish-img"},[_c('img',{attrs:{"src":_vm.dishImg,"alt":""}})]),_vm._v(" "),_c('img',{ref:"dishicon",staticClass:"dish-icon",attrs:{"src":__webpack_require__("42vp"),"alt":""},on:{"click":_vm.handleDishClick}})]),_vm._v(" "),_c('div',{staticClass:"number"},[_vm._v("01")])]),_vm._v(" "),_c('div',{staticClass:"lace"})]),_vm._v(" "),_c('div',{ref:"tab",staticClass:"tab"},[_c('div',{staticClass:"point",attrs:{"slot":"tab-point"},slot:"tab-point"},_vm._l((_vm.list),function(item,index){return _c('span',{key:index,staticStyle:{"display":"none"}})}),0),_vm._v(" "),_c('div',{staticClass:"content",attrs:{"slot":"tab-content"},slot:"tab-content"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,ref:"items",refInFor:true,staticStyle:{"height":"460px"},attrs:{"id":item.id}},[_c('index-item',{attrs:{"img":item.img,"title":item.title,"mode":item.mode,"text":item.text,"index":index},on:{"next":_vm.itemNext}})],1)}),0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mark"},[_vm._v("颠覆传统销售模式"),_c('br'),_vm._v("撬动千亿级市场")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "azX7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4-4.2cbe036.png";

/***/ }),

/***/ "bJQ2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexPartThree_vue__ = __webpack_require__("17Js");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e05ecd08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexPartThree_vue__ = __webpack_require__("YeFZ");
function injectStyle (ssrContext) {
  __webpack_require__("YisL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e05ecd08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexPartThree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e05ecd08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexPartThree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bRi5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_join_success_vue__ = __webpack_require__("zBjI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25b70545_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_join_success_vue__ = __webpack_require__("KgEV");
function injectStyle (ssrContext) {
  __webpack_require__("ZWHs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25b70545"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_join_success_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25b70545_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_join_success_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c0mY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/01chahua4.2bcdef1.png";

/***/ }),

/***/ "ceDL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dYhO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"part"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"copyright"},[_vm._v("\n    ©2010-"+_vm._s(_vm.year)+" 广州群应用网络科技有限公司 "),_c('a',{attrs:{"href":"http://beian.miit.gov.cn","target":"_blank"}},[_vm._v("粤ICP备17114055号")]),_vm._v("     地址： 广州市天河区华景路37号暨南大学科技园6楼\n  ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"con"},[_c('div',{staticClass:"left"},[_c('div',[_c('span',{staticClass:"icon-logo"}),_vm._v(" "),_c('span',{staticClass:"left-title"},[_vm._v("为销售赋能的小程序名片")])]),_vm._v(" "),_c('div',{staticClass:"nav"},[_c('a',{staticClass:"nav-item",attrs:{"href":"/siteindex/#/"}},[_vm._v("小官网")]),_vm._v(" "),_c('a',{staticClass:"nav-item",attrs:{"href":"/card/#/"}},[_vm._v("小名片")]),_vm._v(" "),_c('a',{staticClass:"nav-item",attrs:{"href":"/#/invest"}},[_vm._v("招商加盟")]),_vm._v(" "),_c('a',{staticClass:"nav-item",attrs:{"href":"/#/help"}},[_vm._v("帮助指引")]),_vm._v(" "),_c('a',{staticClass:"nav-item",attrs:{"href":"/#/about"}},[_vm._v("关于我们")])]),_vm._v(" "),_c('div',{staticClass:"links"},[_c('span',[_vm._v("友情链接： ")]),_c('a',{attrs:{"href":"http://www.apluscap.com/","target":"_blank"}},[_vm._v("洪泰基金")]),_c('a',{attrs:{"href":"http://www.taiyoufund.com/","target":"_blank"}},[_vm._v("泰有投资")]),_c('a',{attrs:{"href":"http://cn.idgcapital.com/","target":"_blank"}},[_vm._v("IDG资本")]),_vm._v(" "),_c('a',{attrs:{"href":"http://www.cmhk.com/main/","target":"_blank"}},[_vm._v("招商局")]),_c('a',{attrs:{"href":"http://www.oppein.com/","target":"_blank"}},[_vm._v("欧派")]),_c('a',{attrs:{"href":"http://www.bbwgw.com/cms/","target":"_blank"}},[_vm._v("北部港湾")]),_c('a',{attrs:{"href":"http://www.geya-watch.com/","target":"_blank"}},[_vm._v("Geya格雅表")]),_c('a',{attrs:{"href":"https://m.kuaidi100.com/","target":"_blank"}},[_vm._v("快递查询")])])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"title"},[_vm._v("联系方式")]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v("电话： 186 8021 1000")]),_vm._v(" "),_c('div',{staticClass:"cell"},[_vm._v("电子邮箱： chenjianjun@xcxzhan.com")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eD7j":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-2.fe2440c.png";

/***/ }),

/***/ "eqKx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-1.77e24af.png";

/***/ }),

/***/ "euKl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_index__ = __webpack_require__("aBSl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_normalize_css__ = __webpack_require__("uMhA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_reset_scss__ = __webpack_require__("BJUD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_reset_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_reset_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_vue__ = __webpack_require__("q29P");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






window.__forceSmoothScrollPolyfill__ = true;
__webpack_require__("Rcjy").polyfill();
__webpack_require__("MQFU");

// FYI: https://www.npmjs.com/package/smoothscroll-polyfill
//require('smoothscroll-polyfill').polyfill()
//require('window.requestanimationframe')

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_1__router_index__["a" /* default */],
  template: '<app/>',
  components: { app: __WEBPACK_IMPORTED_MODULE_4__app_vue__["a" /* default */] }
});

/***/ }),

/***/ "euOj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_dom__ = __webpack_require__("xfd8");
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      active: 0
    };
  },
  mounted: function mounted() {
    var _$refs = this.$refs,
        point = _$refs.point,
        content = _$refs.content;

    if (point.children.length <= 0 || content.children.length <= 0) return;
    var pointChilds = point.children ? point.children[0].children : point.children,
        contentChilds = content.children ? content.children[0].children : content.children;
    this.tabCount = pointChilds.length;
    //给每个point item 加上index
    for (var i = 0; i < pointChilds.length; i++) {
      var el = pointChilds[i];
      el.style.cursor = 'pointer';
      el.setAttribute("data-index", i);
      el.addEventListener('click', this.handleItemClick);
    }
    //默认第一个tab content 才渲染
    pointChilds[0] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_dom__["b" /* addClass */])(pointChilds[0], 'active');
    //给第一个添加Class active
    for (var _i = 1; _i < contentChilds.length; _i++) {
      var _el = contentChilds[_i];
      _el.style.display = 'none';
    }
    this.pointChilds = pointChilds;
    this.contentChilds = contentChilds;
  },

  methods: {
    handleItemClick: function handleItemClick(e) {
      var index = parseInt(e.currentTarget.getAttribute('data-index')),
          content = this.contentChilds[index];
      this.contentChilds[this.active].style.display = 'none';
      // 移除active class
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_dom__["c" /* removeClass */])(this.pointChilds[this.active], 'active');
      content.style.display = 'block';
      this.active = index;
      // 给新的添加active
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_dom__["b" /* addClass */])(this.pointChilds[this.active], 'active');
      this.$emit("tab", index);
    },
    showAll: function showAll(flag) {
      var display = flag ? 'block' : 'none',
          contentChilds = this.contentChilds;
      for (var i = 0, length = contentChilds.length; i < length; i++) {
        var c = contentChilds[i];
        c.style.display = display;
      }

      if (!flag) {
        this.active = 0;
        contentChilds[0].style.display = 'block';
      }
    },
    tab: function tab(index) {
      this.pointChilds[index].click();
    }
  }
});

/***/ }),

/***/ "ex59":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-1.514b9e5.png";

/***/ }),

/***/ "f2EM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fKKX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fgbq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4-3.dc4d534.png";

/***/ }),

/***/ "g11x":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/05chahua1.f1b4cff.png";

/***/ }),

/***/ "hkVJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kQvN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5-2.2b657e7.png";

/***/ }),

/***/ "lrYJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-2.5415338.png";

/***/ }),

/***/ "nfro":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nlmA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var frame = 16;

function stepCaller(step) {
  if (window.requestAnimationFrame) {
    window.requestAnimationFrame(step);
  } else {
    setTimeout(function () {
      step();
    }, frame);
  }
}

function animate(el, prop, final, duration) {
  console.log('animate', el[prop], 'final', final);
  //拿到当前的属性值
  var start = el[prop];
  var delta = final - start,
      stepDelta = Math.floor(delta / duration * frame); // 取整数提高性能
  if (!stepDelta) return; // 不是有效的属性值和duration
  var step = function step() {
    stepCaller(function () {
      start += stepDelta;
      if (Math.abs(final - start) <= Math.abs(stepDelta)) start = final;
      el[prop] = start;
      console.log('start', start);
      start !== final && step();
    });
  };
  step();
}

/* unused harmony default export */ var _unused_webpack_default_export = (animate);

/***/ }),

/***/ "oEwB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oG5k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),

/***/ "ozb2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5-3.f4f1d4b.png";

/***/ }),

/***/ "q29P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__("8krA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_235da585_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__("S+vg");
function injectStyle (ssrContext) {
  __webpack_require__("hkVJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-235da585"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_235da585_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qGuv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("xSCp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_311834f5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("yO3g");
function injectStyle (ssrContext) {
  __webpack_require__("ceDL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-311834f5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_311834f5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qZYs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-3.68454c5.png";

/***/ }),

/***/ "qy4u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__join__ = __webpack_require__("4blp");
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {
    Join: __WEBPACK_IMPORTED_MODULE_0__join__["a" /* default */]
  }
});

/***/ }),

/***/ "r+22":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/05chahua8.b413872.png";

/***/ }),

/***/ "rKbF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dish4.0044db7.png";

/***/ }),

/***/ "sXQ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tab_vue__ = __webpack_require__("euOj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8218952e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tab_vue__ = __webpack_require__("F2gn");
function injectStyle (ssrContext) {
  __webpack_require__("/ciH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8218952e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8218952e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sb7x":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dish1.95fb7c6.png";

/***/ }),

/***/ "tOKy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner-chahua2.008537a.png";

/***/ }),

/***/ "tu8q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',{staticClass:"item"},[_c('img',{class:['item-img', _vm.mode == 'right' ? 'item-img-r' : ''],attrs:{"src":_vm.img,"alt":""}}),_vm._v(" "),_c('div',{class:['info', _vm.mode == 'right' ? 'info-r' : '']},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._l((_vm.text),function(item,index){return _c('p',{key:index,staticClass:"info-p"},[_vm._v(_vm._s(item))])})],2),_vm._v(" "),_c('div',{class:['arrow', _vm.mode == 'right' ? 'arrow-r' : ''],staticStyle:{"display":"none"},on:{"click":_vm.next}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uIOS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_tab__ = __webpack_require__("sXQ6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tabActive: 0
    };
  },

  methods: {
    tab: function tab(index) {
      this.tabActive = index;
    },
    handleMouseEnter: function handleMouseEnter(e) {
      var index = +e.currentTarget.getAttribute('data-index');
      this.$refs.tab.tab(index);
    }
  },
  components: {
    Tab: __WEBPACK_IMPORTED_MODULE_0__common_tab__["a" /* default */]
  }
});

/***/ }),

/***/ "uMhA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ua9D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = invest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



function invest(data) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('https://api.xcxzhan.com/site/site/invest', data).then(function (res) {
    if (res.data.code === 0) {
      return true;
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('return code error');
    }
  });
}

/***/ }),

/***/ "v4eZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-1.378751a.png";

/***/ }),

/***/ "xESo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4-1.80e2eb2.png";

/***/ }),

/***/ "xJbw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-2.03c77b0.png";

/***/ }),

/***/ "xSCp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_tab__ = __webpack_require__("sXQ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_business_IndexPartOne__ = __webpack_require__("U3uk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_business_IndexPartTwo__ = __webpack_require__("D9GN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_business_IndexPartThree__ = __webpack_require__("bJQ2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_business_IndexPartFour__ = __webpack_require__("IpGy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_business_IndexpartFive__ = __webpack_require__("54WX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_business_IndexPartSix__ = __webpack_require__("NMB9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_animate__ = __webpack_require__("nlmA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_scrollMixin__ = __webpack_require__("O38v");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__common_scrollMixin__["a" /* default */]],
  data: function data() {
    return {
      bannerActive: 0
    };
  },

  methods: {
    // banner 点击point 切换事件
    bannerTab: function bannerTab(index) {
      this.bannerActive = index;
      clearTimeout(this.$bannerTimer);
      this.changeBanner();
    },

    // 开启定时切换
    changeBanner: function changeBanner() {
      var _this = this;

      this.$bannerTimer = setTimeout(function () {
        _this.$refs.bannerTab.tab((_this.bannerActive + 1) % 3);
      }, 8000);
    }
  },
  mounted: function mounted() {
    this.changeBanner();
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.$bannerTimer);
  },

  components: {
    Tab: __WEBPACK_IMPORTED_MODULE_0__components_common_tab__["a" /* default */],
    IndexPartOne: __WEBPACK_IMPORTED_MODULE_1__components_business_IndexPartOne__["a" /* default */],
    IndexPartTwo: __WEBPACK_IMPORTED_MODULE_2__components_business_IndexPartTwo__["a" /* default */],
    IndexPartThree: __WEBPACK_IMPORTED_MODULE_3__components_business_IndexPartThree__["a" /* default */],
    IndexPartFour: __WEBPACK_IMPORTED_MODULE_4__components_business_IndexPartFour__["a" /* default */],
    IndexPartFive: __WEBPACK_IMPORTED_MODULE_5__components_business_IndexpartFive__["a" /* default */],
    IndexPartSix: __WEBPACK_IMPORTED_MODULE_6__components_business_IndexPartSix__["a" /* default */]
  }
});

/***/ }),

/***/ "xSk2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xfd8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = addClass;
/* unused harmony export hasClass */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeClass;
/* unused harmony export prefixStyle */
/* harmony export (immutable) */ __webpack_exports__["a"] = getWindowScrollTop;
/*
* @Author: lee
* @Date:   2018-01-14 17:38:22
* @Last Modified by:   lee
* @Last Modified time: 2018-01-14 18:18:46
*/
function addClass(el, className) {

  if (hasClass(el, className)) return;
  var newClass = el.className.split(' ');
  newClass.push(className);

  el.className = newClass.join(' ');
}
function hasClass(el, className) {
  var reg = new RegExp('(^|\\s)' + className + '(\\s|$)');
  return reg.test(el.className);
}

//移除class
function removeClass(el, className) {
  if (!hasClass(el, className)) return;
  var newClass = el.className.split(' ').filter(function (item) {
    return item !== className;
  });
  el.className = newClass.join('');
}

/* css属性prefix */
var elementStyle = document.createElement("div").style;
var vendor = function () {
  var transformNames = {
    webkit: 'webkitTransform',
    Moz: 'MozTransform',
    O: 'OTransform',
    ms: 'msTransform',
    standard: 'transform'
  };
  for (var key in transformNames) {
    if (elementStyle[transformNames[key]] !== undefined) {
      //console.log("key",key)
      return key;
    }
  }
  return false;
}();

function prefixStyle(style) {
  if (vendor === false) return false;
  if (vendor === 'standard') return style;
  return vendor + style.charAt(0).toUpperCase() + style.substr(1);
}

function getWindowScrollTop() {
  return document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
}

/***/ }),

/***/ "yO3g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"banner"},[_c('div',{staticClass:"banner-con"},[_c('tab',{ref:"bannerTab",on:{"tab":_vm.bannerTab}},[_c('div',{staticClass:"point",attrs:{"slot":"tab-point"},slot:"tab-point"},[_c('span',{staticClass:"point-item"}),_vm._v(" "),_c('span',{staticClass:"point-item"}),_vm._v(" "),_c('span',{staticClass:"point-item"})]),_vm._v(" "),_c('div',{staticClass:"content",attrs:{"slot":"tab-content"},slot:"tab-content"},[_c('div',{staticClass:"content-item"},[_c('transition',{attrs:{"name":"fade"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.bannerActive == 0),expression:"bannerActive == 0"}],staticClass:"banner-img",attrs:{"src":__webpack_require__("/Rpi"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"banner-info"},[_c('div',{key:0,staticClass:"title"},[_vm._v("小程序 大商机")]),_vm._v(" "),_c('div',{key:1,staticClass:"small"},[_vm._v("与你共掘千亿市场，共享微信10亿月活")]),_vm._v(" "),_c('div',{key:2,staticClass:"s-small"},[_vm._v("MINI PROGRAM"),_c('br'),_vm._v("BIG BUSINESS OPPORTUNITIES")])])],1),_vm._v(" "),_c('div',{staticClass:"content-item"},[_c('transition',{attrs:{"name":"fade"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.bannerActive == 1),expression:"bannerActive == 1"}],staticClass:"banner-img no-left",attrs:{"src":__webpack_require__("tOKy"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"banner-info"},[_c('div',{staticClass:"title"},[_vm._v("全球代理火热招募中")]),_vm._v(" "),_c('div',{staticClass:"small"},[_vm._v("掘金4000+万家企业，共享亿万红利")]),_vm._v(" "),_c('div',{staticClass:"s-small"},[_vm._v("The global agent in recruiting ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-more",on:{"click":function($event){return _vm.$router.push('invest')}}},[_vm._v("了解详情")])])],1),_vm._v(" "),_c('div',{staticClass:"content-item"},[_c('transition',{attrs:{"name":"fade"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.bannerActive == 2),expression:"bannerActive == 2"}],staticClass:"banner-img no-left",attrs:{"src":__webpack_require__("AUVv"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"banner-info"},[_c('div',{staticClass:"title"},[_vm._v("全球代理火热招募中")]),_vm._v(" "),_c('div',{staticClass:"small"},[_vm._v("与其谈小程序风口，不如多给客户带来一些订单更实在")]),_vm._v(" "),_c('div',{staticClass:"s-small"},[_vm._v("Brings to the customer order some more")]),_vm._v(" "),_c('button',{staticClass:"btn btn-more",on:{"click":function($event){return _vm.$router.push('invest')}}},[_vm._v("了解详情")])])],1)])])],1)]),_vm._v(" "),_c('index-part-one',{ref:"partOne",attrs:{"id":"index-part-one"}}),_vm._v(" "),_c('index-part-two'),_vm._v(" "),_c('index-part-three'),_vm._v(" "),_c('div',{staticClass:"bg-wrapper"},[_c('div',{staticClass:"bg-wrap"}),_vm._v(" "),_c('index-part-four')],1),_vm._v(" "),_c('index-part-five'),_vm._v(" "),_c('index-part-six')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yvie":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/01chahua3.f001b81.png";

/***/ }),

/***/ "z2iv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      year: new Date().getFullYear()
    };
  },

  components: {}
});

/***/ }),

/***/ "z67V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zBjI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isShow: false
    };
  },

  methods: {
    maskClick: function maskClick(e) {
      this.isShow = false;
    },
    show: function show(f) {
      this.isShow = f;
    }
  }

});

/***/ })

},[6]);


// WEBPACK FOOTER //
// static/js/zcx.692a60d7cd726d42199f.js